import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import Icon from "../Icon";

const offerings = [
  {
    icon: "phone",
    accent: "blue",
    title: "Free Discovery Call",
    desc: "30-min session with our engineers to map your product vision and identify the right tech approach.",
    tag: "Start Here",
  },
  {
    icon: "brain",
    accent: "indigo",
    title: "Custom AI & SaaS Build",
    desc: "From LLM-powered automation to full SaaS platforms — secure, scalable, and built for production.",
    tag: "Core Service",
  },
  {
    icon: "rocket",
    accent: "violet",
    title: "Launch on Unibuilder",
    desc: "Go live faster with our flagship platform — role-based, multi-tenant, and production-ready from day one.",
    tag: "Flagship Product",
  },
];

export default function ReadyToBuild() {
  const navigate = useNavigate();

  return (
    <section className="rtb-section">
      {/* Aurora blobs */}
      <div className="rtb-aurora rtb-aurora--purple" aria-hidden="true" />
      <div className="rtb-aurora rtb-aurora--blue" aria-hidden="true" />
      <div className="rtb-aurora rtb-aurora--indigo" aria-hidden="true" />

      {/* Dot grid */}
      <div className="rtb-grid" aria-hidden="true" />

      <div className="container rtb-container">
        {/* Header */}
        <div className="rtb-header">
          <h2 className="rtb-title">
            Your Next Product Starts
            <span className="rtb-title-accent"> with One Conversation.</span>
          </h2>

          <p className="rtb-subtitle">
            An AI-first product engineering team building secure, scalable
            software — from idea to production, and beyond.
          </p>

          <div className="rtb-cta-row">
            <button
              type="button"
              className="rtb-btn-primary"
              onClick={() => navigate("/about/contact")}
            >
              Start Free Discovery Call
              <Icon name="arrowRight" size={18} className="bct-icon--nudge" />
            </button>
            <button
              type="button"
              className="rtb-btn-ghost"
              onClick={() => navigate("/products/unibuilder")}
            >
              View Our Work
            </button>
          </div>
        </div>

        {/* Offering Cards */}
        <div className="row g-4 justify-content-center rtb-offerings">
          {offerings.map((item, i) => (
            <div key={i} className="col-lg-4 col-md-4 col-12">
              <div className="rtb-offering-card icon-hover">
                <div className="rtb-card-top">
                  <div
                    className={`rtb-offering-icon rtb-offering-icon--${item.accent}`}
                  >
                    <Icon name={item.icon} size={26} />
                  </div>
                  <span className="rtb-card-tag">{item.tag}</span>
                </div>
                <h4 className="rtb-offering-title">{item.title}</h4>
                <p className="rtb-offering-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
